import { PermittedAction } from "./common";

export type IssuePermissionPermittedAction =
  | PermittedAction.Delete
  | PermittedAction.CanEdit;

export enum ProjectMemberType {
  Role = "role",
  User = "user",
  Company = "company",
}

export interface IssuePermission {
  id: string;
  subject: string;
  subjectType: ProjectMemberType;
  permittedActions: IssuePermissionPermittedAction[];
  permittedAttributes: "permissionLevel"[];
  permissionLevel: AnyIssuePermissionLevel;

  /**
   * TODO(visibility-by-type): when BE cleans up their FF, the following two
   * fields can be changed to required, and downstream checks simplified.
   */
  allTypes?: boolean;
  /** From batch GET; ignored when `allTypes` is true. */
  permittedTypesCount?: number;
  /** From single-permission GET; lazy when opening the type picker (Phase 4). */
  permittedTypes?: string[];
}

export enum OldIssuePermissionLevel {
  CreateForMyCompany = "create-for-my-company",
  CreateForOtherCompanies = "create-for-other-companies",
  ManageIssues = "manage-issues",
  ManageMemberPermissions = "manage-member-permissions",
}

export enum NewIssuePermissionLevel {
  ViewEditAndAssignMyCompany = "view-edit-and-assign-my-company",
  ViewEditAndAssignAll = "view-edit-and-assign-all",
  FullVisibility = "full-visibility",
  ManageIssues = "manage-issues",
  ManageMemberPermissions = "manage-member-permissions",
}
export type AnyIssuePermissionLevel =
  | OldIssuePermissionLevel
  | NewIssuePermissionLevel;

export const oldPermissionLevelOrder: Record<OldIssuePermissionLevel, number> =
  {
    [OldIssuePermissionLevel.CreateForMyCompany]: 1,
    [OldIssuePermissionLevel.CreateForOtherCompanies]: 2,
    [OldIssuePermissionLevel.ManageIssues]: 3,
    [OldIssuePermissionLevel.ManageMemberPermissions]: 4,
  };

export const newPermissionLevelOrder: Record<NewIssuePermissionLevel, number> =
  {
    [NewIssuePermissionLevel.ViewEditAndAssignMyCompany]: 1,
    [NewIssuePermissionLevel.ViewEditAndAssignAll]: 2,
    [NewIssuePermissionLevel.FullVisibility]: 3,
    [NewIssuePermissionLevel.ManageIssues]: 4,
    [NewIssuePermissionLevel.ManageMemberPermissions]: 5,
  };

export interface IssuePermissionBatchCreateResourceAttributesBase {
  permissionLevel: AnyIssuePermissionLevel;
  subject: string;
  subjectType: ProjectMemberType;
}

/** Type visibility fields returned from **batch GET**. */
export interface IssuePermissionTypeVisibilityBatchRead {
  allTypes: boolean;
  permittedTypesCount: number;
}

/**
 * Type visibility fields sent in POST/PATCH.
 * TODO(visibility-by-type): when BE cleans up their FF, this type stops being
 * optional on types below.
 */
export interface IssuePermissionTypeVisibilityWrite {
  allTypes: boolean;
  permittedTypes: string[];
}

/** POST batch create body per row. */
export type IssuePermissionBatchCreateResourceAttributes =
  IssuePermissionBatchCreateResourceAttributesBase &
    Partial<IssuePermissionTypeVisibilityWrite>;

export type IssuePermissionBatchCreateResource =
  IssuePermissionBatchCreateResourceAttributes & { id: string };

export type IssuePermissionUpdateAttributes = {
  permissionLevel: AnyIssuePermissionLevel;
} & Partial<IssuePermissionTypeVisibilityWrite>;
